window.Sertif = function () {
  var HandleAjaxParam = function () {
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      beforeSend: function (jqXHR, settings)
      {
       $('.loader').show();

     },
     timeout: function () {
      $('.loader').hide();
    },
    complete: function () {
      $('.loader').hide();

    },
    success: function () {
      $('.loader').hide();
    },
    error: function (jqXHR, textStatus, errorThrown) {
      $('.loader').hide();
      Sertif.WindowNotif('ERROR', jqXHR.responseText, 'error');
    },
    fail: function (jqXHR, textStatus) {
      $('.loader').hide();
      Sertif.WindowNotif('ERROR', jqXHR.statusText, 'error');
    }
  });
  };

  return {

     Init: function () {
        HandleAjaxParam();
     },
     WindowNotif: function (title, msg, type) {
      if (type == 'error') {
        toastr.options = {
          "closeButton": true,
          "positionClass": "toast-bottom-right",
        }
        toastr.error(msg, title);
      }else if(type == 'success'){
        toastr.options = {
          "closeButton": true,
          "positionClass": "toast-bottom-right",
        }
        toastr.success(msg, title);
      }
     },

  };
}()
jQuery(document).ready(function () {
   Sertif.Init();
});